import React from "react";
import img1 from "../images/program-antyplagiatowy-wrona-1.webp"
import img2 from "../images/program-antyplagiatowy-wrona-2.webp"
import img3 from "../images/program-antyplagiatowy-wrona-3.webp"

export const Links1 = () => [
  <div className="default-block container" style={{marginTop: 30, marginBottom: 70}} key={0}>
    <div className="wp-block-columns">
      <div className="default-block container">
        <div className="wp-block-column">
          <a href="https://poprawaprac.pl/jednolity-system-antyplagiatowy-jsa/" style={{color: 'inherit'}}>
            <img src={img1} alt="Jak działa Jednolity System Antyplagiatowy"/>
          </a>
        </div>
      </div>
  
      <div className="default-block container">
        <div className="wp-block-column">
          <h4 style={{marginTop:15, fontWeight: 600, textAlign: 'center', color: '#f54d4d'}}>95,99% podobieństwa z JSA</h4>
          <h4 style={{marginBottom: 0, fontWeight: 600, textAlign: 'center'}}>Algorytm na wzór JSA</h4>
          <h4 style={{marginTop: 0, fontWeight: 600, textAlign: 'center'}}>Analiza na podstawie raportu JSA</h4>
          <h4 style={{fontWeight: 600, textAlign: 'center', color: '#f54d4d'}}>Ekspresowy wynik</h4>
        </div>
      </div>
    </div>
  </div>,
  
  <div className="default-block container" style={{marginTop: 30, marginBottom: 70}} key={1}>
    <div className="wp-block-columns">
      <div className="default-block container">
        <div className="wp-block-column">
          <h4 style={{marginTop: 0, textAlign: "left", fontWeight: 600}}>
            <a href="https://poprawaprac.pl/jednolity-system-antyplagiatowy-jsa/" style={{color: 'inherit', wordBreak: 'normal'}}>Jak działa Jednolity System Antyplagiatowy</a>
          </h4>
          <div>
            Zrozum algorytm JSA i napisz pracę bez plagiatu. Dowiedz się jakich argumentów użyć w rozmowie z promotorem jeżeli pisałeś pracę samodzielnie a wynik w JSA przekroczył dopuszczalny próg.
          </div>
        </div>
      </div>
      
      <div className="default-block container">
        <div className="wp-block-column">
          <a href="https://poprawaprac.pl/jednolity-system-antyplagiatowy-jsa/" style={{color: 'inherit'}}>
            <img src={img2} alt="Jak działa Jednolity System Antyplagiatowy"/>
          </a>
        </div>
      </div>
    </div>
  </div>,
  
  <div className="default-block container" style={{paddingBottom: 40}} key={2}>
    <div className="wp-block-columns">
      <div className="default-block container">
        <div className="wp-block-column">
          <a href="https://poprawaprac.pl/raport-z-antyplagiatu-wrona/" style={{color: 'inherit'}}>
            <img alt="Zobacz przykładowy raport z Antyplagiatu Wrona" src={img3}/>
          </a>
        </div>
      </div>

      <div className="default-block container">
        <div className="wp-block-column">
          <h4 style={{marginTop: 0, textAlign: "left", fontWeight: 600}}>
            <a href="https://poprawaprac.pl/raport-z-antyplagiatu-wrona/" style={{color: 'inherit', wordBreak: 'normal'}}>Zobacz przykładowy raport z Antyplagiatu Wrona</a>
          </h4>
          <div>
            Wynik w moim antyplagiacie jest w 95,9 % zbieżny z wynikiem JSA. Zobacz jak należy interpretować raport i które fragmenty musisz bezwzględnie poprawić, aby praca przeszła pomyślną weryfikację antyplagiatową na Twojej uczelni!
          </div>
        </div>
      </div>
    </div>
  </div>
];
